import { projectsList } from '../assets/projects.js';
import Project from './Project';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

export default function Projects() {
  
  return (
    <div className="flex flex-col items-center  bg-peach p-4 z-0 w-full pt-20" id="Projects">
        <h1 className='mb-2 md:text-5xl text-4xl text-darkBrown font-headers'>My Recent Projects</h1>
        {projectsList.map((proj) => (
          <div key={proj.title} className=' w-5/6'>
            <Project key={proj.title} proj={proj} />
          </div>
        ))}
    </div>
  );
}
